import React from 'react';
import { arrayOf, string, object, node } from 'prop-types';
import { logger } from '@fiverr-private/obs';
import { LazyComponent } from '@fiverr-private/orca';

const NotableClientsAboutClosable = ({
    notableClients,
    origin,
    title,
    className = '',
    logoClassName
}) => {
    const titleProps = {
        educate: false,
        newBadge: false,
        infoIcon: false,
        title,
        classNames: {
            title: 'tbody-5'
        }
    };
    const lazyOnError = (error) => logger.error(error, { description: 'Failed to lazy load NotableClientsAbout' });
    const lazyImport = () => import(
        /* webpackChunkName: 'NotableClientsAbout' */ '../NotableClientsAbout'
    );
    const componentProps = {
        notableClients,
        isSlimDesign: true,
        origin,
        hideClientPopover: true,
        titleProps,
        className,
        logoClassName
    };

    return (
        <LazyComponent lazyImport={lazyImport}
            shouldImport={true}
            componentProps={componentProps}
            onError={lazyOnError}/>
    );
};

NotableClientsAboutClosable.propTypes = {
    notableClients: arrayOf(object),
    origin: string,
    className: string,
    logoClassName: string,
    title: node
};

export default NotableClientsAboutClosable;
